/**
 * 将workbench ui的id包装成大图标的id
 * @param workbenchId
 */
export function wrapIdForBig(workbenchId): string {
    return `${workbenchId}-workbench-big`;
}

/**
 * 将workbench ui的id包装成input样式的id
 * @param workbenchId
 */
export function wrapIdForInput(workbenchId): string {
    return `${workbenchId}-workbench-input`;
}

/**
 * 表格工具栏后缀
 * @param workbenchId
 */
export function wrapIdForTableTabInput(workbenchId): string {
    return `${workbenchId}-workbench-table-tab-input`;
}

/**
 * 自定义content缀
 * @param workbenchId
 */
export function wrapIdForCustomContent(workbenchId): string {
    return `${workbenchId}-workbench-custom-content`;
}

/**
 * 将workbench ui的id包装成文本样式的id
 * @param workbenchId
 */
export function wrapIdForText(workbenchId): string {
    return `${workbenchId}-workbench-text`;
}

/**
 * 将workbench ui的id包装成收折的id
 * @param workbenchId
 */
export function wrapIdForFold(workbenchId): string {
    return `${workbenchId}-workbench-fold`;
}

export function wrapIdForVip(workbenchId): string {
    return `${workbenchId}-workbench-vip`;
}

export function wrapIdForPic(workbenchId): string {
    return `${workbenchId}-workbench-picture`;
}

export function wrapIdForCommon(workbenchId): string {
    return `${workbenchId}-workbench-common`;
}

export function wrapIdForTopMenuHor(workbenchId): string {
    return `${workbenchId}-workbench-top-menu-hor`;
}

export function wrapIdForTextTab(workbenchId): string {
    return `${workbenchId}-workbench-text-tab`;
}
